import React from 'react';
import { Collapse, Form, Col } from 'react-bootstrap';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import FormField from '../../../forms/FormField';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import { getCheckZip } from '../../../../api/api';

const required = value => value ? undefined : 'Required';
const requiredNumber = value => value || value === 0 ? undefined : 'Required';
const validDate = value =>
  value &&
    moment(value).isValid() &&
    moment(value).isAfter(moment().startOf('day'))
    ? undefined
    : 'Invalid';

const DELIVER = 'DELIVER';
const PICKUP = 'PICKUP';
const PICKUP_CALISTOGA_SHIPVIAID = 8;
const PICKUP_HEALDSBURG_SHIPVIAID = 12;
const PICKUP_TWOMEY_NORTH_SHIPVIAID = 33;
const PICKUP_TWOMEY_OREGON_SHIPVIAID = 34;

const getDOB = dob => {
  if (!dob || !moment(dob).isValid()) return null;
  const m = moment(dob);

  return {
    dob_month: m.month(),
    dob_day: m.date(),
    dob_year: m.year()
  };
};

const shipDateFilter = shipViaId =>
  d => {
    if (!d) return true;
    const day = d.getDay();
    const daysToShip = shipViaId === 9 ? 1 : 2;
    const isBeforeToday = moment()
      .add(daysToShip, 'days')
      .startOf('day')
      .isAfter(moment(d));
    if (isBeforeToday) return false;
    if (shipViaId === 9) return [2, 3, 4, 5].some(x => x === day);
    return [3, 4, 5].some(x => x === day);
  };

const pickupDateFilter = shipViaId =>
  d => {
    if (!d) return true;
    // const day = d.getDay();
    const isBeforeToday = moment().startOf('day').isAfter(moment(d));
    if (isBeforeToday) return false;
    return true;
  };

const filterMonth = ({ value, label }, search) => {
  const l = (label || '').trim().toLowerCase();
  const compare = (search || '').toLowerCase();
  if ((l || '').startsWith(compare)) return true;
  if (isNaN(search)) return false;
  try {
    const num = parseInt(search);
    return num === value + 1;
  } catch (err) {
    return false;
  }
};

const CheckoutShippingForm = props => {
  const {
    handleSubmit,
    lookups,
    deliveryMethodValue,
    isGiftValue,
    makeDefaultShippingValue,
    shipViaIdValue,
    change,
    loggedIn,
    AddressBook,
    submitting,
    submitFailed,
    invalid,
    requiresShipDate,
    shipDates
  } = props;

  const {
    states,
    shippers
  } = lookups || {};

  const shippingDropdownOptions = (shipDates || [])
    .filter(({ shippingServiceId }) => shippingServiceId === shipViaIdValue)
    .filter(
      ({ requestedShipDate }) =>
        moment(requestedShipDate).isValid() &&
        moment(requestedShipDate).isAfter(moment())
    )
    .map(({ requestedShipDate }) => ({
      value: requestedShipDate,
      label: moment(requestedShipDate).format('MM/DD/YYYY')
    }));

  const showShippingDropdown = requiresShipDate &&
    shippingDropdownOptions.length > 0
    ? true
    : false;

  const daysToShip = shipViaIdValue === 9 ? 1 : 2;

  const stateOptions = (states || [])
    .filter(({ countryId }) => countryId === 37)
    .map(({ stateId, stateName }) => ({
      value: stateId,
      label: stateName
    }));

  const shipperOptions = (shippers || [])
    .filter(({ brandingId }) => brandingId !== 3)
    .map(({ shipTrackingTypeId, shipTrackingName }) => ({
      value: shipTrackingTypeId,
      label: shipTrackingName
    }));

  const isDelivery = deliveryMethodValue === DELIVER;

  const handleChangeDeliveryMethod = value =>
    () => {
      change('deliveryMethod', value);
      change('shipViaId', null);
    };

  const addressBookOptions = (AddressBook || []).map(address => {
    const { Label, Address1, City } = address || {};

    return {
      value: address,
      label: `${Label || ''} ${Address1 || ''} ${City || ''}`
    };
  });

  const handleAddressBookChange = address => {
    const {
      FirstName: name_first,
      LastName: name_last,
      Company: company,
      Address1: address1,
      Address2: address2,
      City: city,
      Zip: zip,
      Phone: phone,
      StateID: stateId,
      DOB: dob
    } = address || {};

    const {
      dob_month,
      dob_day,
      dob_year
    } = getDOB(dob) || {};

    change('name_first', name_first);
    change('name_last', name_last);
    change('company', company);
    change('address1', address1);
    change('address2', address2);
    change('city', city);
    change('zip', zip);
    change('phone', phone);
    change('stateId', stateId);
    change('dob_month', dob_month);
    change('dob_day', dob_day);
    change('dob_year', dob_year);
  };

  return (
    <Form onSubmit={handleSubmit}>

      <section>
        <h5>Pickup / Delivery Options</h5>
        <div className="padded">
          <div className="row">
            <div className="col-6 col-md-3 col-lg-2 form-group">
              <div className="form-check inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="deliveryMethod"
                  value={DELIVER}
                  checked={deliveryMethodValue === DELIVER}
                  onChange={handleChangeDeliveryMethod(DELIVER)}
                />
                <label className="form-check-label">
                  Deliver
                </label>
              </div>
            </div>
            {/* TODO temp comment out pickup options */}
            {/* <div className="col-6 col-md-3 col-lg-3 form-group">
              <div className="form-check inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  value={PICKUP}
                  onChange={handleChangeDeliveryMethod(PICKUP)}
                  checked={deliveryMethodValue === PICKUP}
                />
                <label className="form-check-label">
                  Pick Up
                </label>
              </div>
            </div>
            {!isDelivery &&
              <div className="col-12 col-md-6 col-lg-7 pick-up-select">
                <Field
                  name="shipViaId"
                  type="number"
                  component={FormField.SelectReact}
                  placeholder="Select Winery For Pick Up"
                  validate={[required]}
                  options={[
                    { value: PICKUP_CALISTOGA_SHIPVIAID, label: 'Calistoga' },
                    { value: PICKUP_HEALDSBURG_SHIPVIAID, label: 'Healdsburg' },
                    {
                      value: PICKUP_TWOMEY_NORTH_SHIPVIAID,
                      label: 'Anderson Valley'
                    }
                    // { value: PICKUP_TWOMEY_OREGON_SHIPVIAID, label: 'Oregon' }
                  ]}
                />
              </div>} */}
          </div>
        </div>
        <br /><br />
        <h5>Important Information</h5>
        <p>
          Alcohol can only be shipped to an address where an individual at least 21 years old can sign for the package during regular business hours. The carrier will make 3 delivery attempts, at which point the package will be returned. We are happy to re-ship returned packages, however an additional shipping fee will incur.
        </p>
        <p>
          We ship all year around, however during extreme hot or cold weather, shipments may be delayed to protect the integrity of your package. Please contact us at (888) 202-2006, Monday - Friday, 8am - 5pm (PT) for alternate shipping options.
        </p>
      </section>

      <section className="form-bit">
        <h3 className="column-header">
          {isDelivery ? 'Shipping Address' : 'Who will pick up this order?'}
        </h3>
        <div className="form-row">
          {loggedIn &&
            isDelivery &&
            <div className="col-md-12">
              <Field
                name="addressBookId"
                type="text"
                component={FormField.SelectReact}
                placeholder="Select from address book"
                options={addressBookOptions}
                onChange={handleAddressBookChange}
              />
              <div className="form-group form-group-gift-checkbox">
                <div
                  className="form-check inline"
                  onClick={() =>
                    change('makeDefaultShipping', !makeDefaultShippingValue)}
                >
                  <input
                    className="form-check-input"
                    type="radio"
                    name="makeDefaultShipping"
                    value="option1"
                    checked={makeDefaultShippingValue}
                  />
                  <label
                    className="form-check-label"
                    style={{ fontSize: '16px', paddingBottom: '10px' }}
                  >
                    Make default shipping address
                  </label>
                </div>
              </div>
            </div>}
          <div className="col-md-6">
            <Field
              name="name_first"
              type="text"
              component={FormField.Input}
              placeholder="First Name"
              validate={[required]}
            />
          </div>
          <div className="col-md-6">
            <Field
              name="name_last"
              type="text"
              component={FormField.Input}
              placeholder="Last Name"
              validate={[required]}
            />
          </div>
        </div>
        {isDelivery &&
          <div>
            <Field
              name="address1"
              type="text"
              component={FormField.Input}
              placeholder="Address"
              validate={[required]}
            />
            <Field
              name="address2"
              type="text"
              component={FormField.Input}
              placeholder="Address 2"
            />
            <div className="form-row">
              <div className="col-md-4">
                <Field
                  name="city"
                  type="text"
                  component={FormField.Input}
                  placeholder="City"
                  validate={[required]}
                />
              </div>
              <div className="col-md-4">
                <Field
                  name="stateId"
                  type="text"
                  component={FormField.SelectReact}
                  placeholder="State"
                  validate={[required]}
                  options={stateOptions}
                />
              </div>
              <div className="col-md-4">
                <Field
                  name="zip"
                  type="text"
                  component={FormField.Input}
                  placeholder="Postal Code"
                />
              </div>
            </div>
            <div className="form-row">
              <div className="col-md-6">
                <Field
                  name="phone"
                  type="text"
                  component={FormField.Input}
                  placeholder="Phone Number"
                  validate={[required]}
                />
              </div>
            </div>
          </div>}
      </section>

      {isDelivery &&
        <section className="form-bit">
          <h3 className="column-header">
            Select Shipping Method
          </h3>
          <p>
            Choose a shipping method and preferred delivery date. Orders are processed within 24-48 hours of receipt. Please call us if you need to expedite your order.
          </p>
          <div className="form-row">
            <div className="col-md-6">
              <Field
                name="shipViaId"
                type="number"
                component={FormField.SelectReact}
                placeholder="Shipping Method"
                validate={[required]}
                options={shipperOptions}
              />
            </div>
            <div className="col-md-6">
              {!showShippingDropdown &&
                <Field
                  name="requestedShipDate"
                  type="text"
                  component={FormField.Datepicker}
                  placeholder="Date"
                  daysAdjustment={daysToShip}
                  validate={[required, validDate]}
                  inputProps={{ filterDate: shipDateFilter(shipViaIdValue) }}
                />}
              {showShippingDropdown &&
                <Field
                  name="requestedShipDate"
                  type="text"
                  component={FormField.SelectReact}
                  placeholder="Date"
                  daysAdjustment={daysToShip}
                  validate={[required, validDate]}
                  options={shippingDropdownOptions}
                />}
            </div>
          </div>
        </section>}
      {!isDelivery &&
        <section className="form-bit">
          <h3 className="column-header">
            I will pick this up on or after
          </h3>
          <div className="form-row">
            <div className="col-md-6">
              <Field
                name="requestedShipDate"
                type="text"
                component={FormField.Datepicker}
                placeholder="Date"
                validate={[required, validDate]}
                inputProps={{ filterDate: pickupDateFilter(shipViaIdValue) }}
              />
            </div>
          </div>
        </section>}

      {isDelivery &&
        <section className="form-bit">
          <h3 className="column-header">Enter Your Birthday</h3>
          <p>
            Shipper will not leave wine without an adult signature. Please make sure an adult is available to sign for delivery. Call us for alternative delivery options.
          </p>
          <div className="form-row">
            <div className="col-md-4">
              <Field
                name="dob_month"
                type="text"
                component={FormField.SelectReact}
                placeholder="Month"
                filterOption={filterMonth}
                validate={[requiredNumber]}
                options={[
                  { value: 0, label: 'January' },
                  { value: 1, label: 'February' },
                  { value: 2, label: 'March' },
                  { value: 3, label: 'April' },
                  { value: 4, label: 'May' },
                  { value: 5, label: 'June' },
                  { value: 6, label: 'July' },
                  { value: 7, label: 'August' },
                  { value: 8, label: 'September' },
                  { value: 9, label: 'October' },
                  { value: 10, label: 'November' },
                  { value: 11, label: 'December' }
                ]}
              />
            </div>
            <div className="col-md-4">
              <Field
                name="dob_day"
                type="text"
                component={FormField.SelectReact}
                placeholder="Day"
                validate={[required]}
                options={Array.from(Array(31), (_, i) => ({
                  value: i + 1,
                  label: i + 1
                }))}
              />
            </div>
            <div className="col-md-4">
              <Field
                name="dob_year"
                type="text"
                component={FormField.SelectReact}
                placeholder="Year"
                validate={[required]}
                options={Array.from(Array(90), (_, i) => ({
                  value: new Date().getFullYear() - 21 - i,
                  label: new Date().getFullYear() - 21 - i
                }))}
              />
            </div>
          </div>
        </section>}

      {isDelivery &&
        <section className="form-bit">
          <h3 className="column-header">
            Gift
          </h3>

          <div className="form-group form-group-gift-checkbox">
            <div
              className="form-check inline"
              onClick={() => change('isGift', !isGiftValue)}
            >
              <input
                className="form-check-input"
                type="radio"
                name="isGift"
                value="option1"
                checked={isGiftValue}
              />
              <label className="form-check-label">
                Is This a Gift?
              </label>
            </div>
          </div>

          <Collapse id="gift-collapse" in={isGiftValue}>
            <div>
              <br />
              <div className="form-row">
                <div className="col-md-6">
                  <Field
                    name="giftSenderName"
                    type="text"
                    component={FormField.Input}
                    placeholder="Gift Sender's Name"
                    validate={isGiftValue ? [required] : []}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-6">
                  <Field
                    name="giftName"
                    type="text"
                    component={FormField.Input}
                    placeholder="Gift Recipient's Name"
                    validate={isGiftValue ? [required] : []}
                  />
                </div>
                <div className="col-md-6">
                  <Field
                    name="giftRecipientEmail"
                    type="email"
                    component={FormField.Input}
                    placeholder="Gift Recipient's Email"
                  />
                </div>
              </div>
              <br />
              <p>
                Write a note with your gift. Don’t forget to include your name. The message will be included in your shipment. (500 character limit)
              </p>
              <Field name="giftNote" rows={6} component={FormField.Textarea} />
            </div>
          </Collapse>
        </section>}

      {!isDelivery &&
        <section className="form-bit">
          <h3 className="column-header">
            Message for recipient
          </h3>
          <p>
            Include a message for recipient (500 character limit).
          </p>
          <Field name="giftNote" rows={6} component={FormField.Textarea} />
        </section>}

      <section className="form-bit">
        <h3 className="column-header">
          Special Instructions
        </h3>
        <Field
          name="specialInstructions"
          rows={6}
          component={FormField.Textarea}
          placeholder="Business instructions, hold for weather, etc"
        />
      </section>

      <section className="form-bit">
        <div className="form-row justify-content-end">
          {invalid &&
            submitFailed &&
            <Col>
              <p style={{ color: '#dc3545' }}>
                Form is invalid. Please fix errors and resubmit
              </p>
            </Col>}
          <div className="col-md-4">
            <button
              type="submit"
              className="btn btn-primary btn-block"
              id="tag-button-shipping"
              disabled={submitting}
            >
              Continue
            </button>
          </div>
        </div>
      </section>

    </Form>
  );
};

const formName = 'checkout-shipping-form';

const asyncValidate = async (values, dispatch, props) => {
  const { lookups } = props || {};
  const { states } = lookups || {};
  const { zip, deliveryMethod } = values;

  const isDelivery = deliveryMethod === DELIVER;

  if (!isDelivery) return;

  if (!zip) throw { zip: 'Required' };

  const result = await getCheckZip(zip);

  if (result.err) {
    return;
  }

  if (!result.valid) {
    throw { zip: 'Invalid Zip Code' };
  }
};

const form = reduxForm({
  form: formName,
  asyncValidate,
  asyncBlurFields: ['zip']
})(CheckoutShippingForm);

const selector = formValueSelector(formName);

const mapState = state => {
  const deliveryMethodValue = selector(state, 'deliveryMethod');
  const isGiftValue = selector(state, 'isGift');
  const makeDefaultShippingValue = selector(state, 'makeDefaultShipping');
  const shipViaIdValue = selector(state, 'shipViaId');
  return {
    deliveryMethodValue,
    isGiftValue,
    makeDefaultShippingValue,
    shipViaIdValue
  };
};

const mapDispatch = dispatch => bindActionCreators({}, dispatch);

export default connect(mapState, mapDispatch)(form);
